<template>
  <div class="flight-pad-horizontal-path">
    <!-- duration -->
    <flight-pad-duration v-if="itinerary.duration" :duration="itinerary.duration" full />
    <div class="flight-pad-horizontal-path__visual">
      <!-- start -->
      <div class="flight-pad-horizontal-path__visual__icon" v-html="svg_flight_start()"></div>
      <div class="flex-grow-1 w-100 d-flex align-items-center">
        <div class="flight-pad-horizontal-path__visual__line" />
      </div>
      <!-- middle (optional) -->
      <div
        v-if="itinerary.segments.length > 1"
        class="flight-pad-horizontal-path__visual__icon"
        v-html="svg_flight_stop()"
      ></div>
      <div v-if="itinerary.segments.length > 1" class="flex-grow-1 w-100 d-flex align-items-center">
        <div class="flight-pad-horizontal-path__visual__line"></div>
      </div>
      <!-- end -->
      <div class="flight-pad-horizontal-path__visual__icon" v-html="svg_plane()"></div>
    </div>
    <flight-pad-stops :itinerary="itinerary" color="primary" />
  </div>
</template>

<script>
import { flight_start, flight_stop, plane } from '@/components/svg/flight';
import FlightPadDuration from '@/components/blocks/flight-pad/flight-pad-duration.vue';
import FlightPadStops from '@/components/blocks/flight-pad/flight-pad-stops.vue';

export default {
  name: 'flight-pad-horizontal-path',
  components: {
    'flight-pad-duration': FlightPadDuration,
    'flight-pad-stops': FlightPadStops,
  },
  props: {
    itinerary: Object,
  },
  methods: {
    svg_plane: plane,
    svg_flight_start: flight_start,
    svg_flight_stop: flight_stop,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-horizontal-path {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__visual {
    width: 100%;
    display: flex;
    padding-left: 10px;
    padding-right: 10px;
    gap: 5px;

    &__line {
      min-width: 100%;
      height: 1px;
      min-height: 1px;
      max-height: 1px;
      border: 1px solid $primary;
      border-radius: 50px;
    }
  }

  @include media-breakpoint-down(md) {
    &__duration {
      display: none;
    }
  }
}
</style>
